/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { ReviewsWrapper } from '../events/styles'
import { Header2, Header3 } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css/bundle'

const reviews = [
  {
    quote: `"Glamsquad was professional, courteous, and the pros were excellent. It's great to have one trusted resource that can provide glam for all my events vs searching for local providers I don't know."`,
    name: 'Gabriela Neves, Factory360',
  },
  {
    quote: `"Your team was absolutely fantastic! They were so personable and professional and talented!"`,
    name: 'Iconic Magazine',
  },
]

const Reviews = () => {
  SwiperCore.use([Pagination, Autoplay, Navigation])

  return (
    <ReviewsWrapper>
      <Header2 color={gsColors.salmon} margin="0 0 32px">
        The reviews are in
      </Header2>
      <div className="swiper-container-container">
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          navigation={{
            nextEl: '.custom-next-button',
            prevEl: '.custom-prev-button',
          }}
          className="swiper-container"
        >
          {reviews.map((r, i) => (
            <SwiperSlide key={i}>
              <div className="rating">
                <div className="star-container">
                  {new Array(5).fill('').map((_, i) => (
                    <img
                      key={i}
                      src="/home/star.svg"
                      width="24"
                      height="24"
                      alt="star"
                    />
                  ))}
                </div>
                <Header3 color="#fff" align="center" margin="0 0 16px 0">
                  {r.quote}
                </Header3>
                <Header3 color="#fff" align="center">
                  - {r.name}
                </Header3>
              </div>
            </SwiperSlide>
          ))}
          <button className="custom-prev-button" />
          <button className="custom-next-button" />
        </Swiper>
      </div>
    </ReviewsWrapper>
  )
}

export default Reviews
